// extracted by mini-css-extract-plugin
module.exports = {"root":"LandingRiverInjector_root__2sFma"};